import { showDialog } from "../../../actions/notifications";
import Banner from "../../../controls/Banner";
import CollapseIcon from "../../../controls/CollapseIcon";
import Dropzone from "../../../controls/Dropzone";
import FlexLayout from "../../../controls/FlexLayout";
import IconBar from "../../../controls/IconBar";
import SuperTable from "../../../controls/Table";
import { convertGameIdReverse } from "../../nexus_integration/util/convertGameId";
import { ComponentEx, connect, translate } from "../../../controls/ComponentEx";
import { DataInvalid, ProcessCanceled, TemporaryError, UserCanceled, } from "../../../util/CustomErrors";
import getVortexPath from "../../../util/getVortexPath";
import { log } from "../../../util/log";
import { showError } from "../../../util/message";
import opn from "../../../util/opn";
import * as selectors from "../../../util/selectors";
import { getSafe } from "../../../util/storeHelper";
import { truthy } from "../../../util/util";
import MainPage from "../../../views/MainPage";
import { setShowDLDropzone, setShowDLGraph } from "../actions/settings";
import { finishDownload, setDownloadTime } from "../actions/state";
import getDownloadGames from "../util/getDownloadGames";
import { DownloadIsHTML } from "@vortex/shared/errors";
import DownloadGraph from "./DownloadGraph";
import _ from "lodash";
import * as path from "path";
import * as React from "react";
import { Button, Panel } from "react-bootstrap";
import { getCollectionModByReference } from "../../../util/selectors";
const nop = () => null;
const DROPZONE_ACCEPT = ["urls", "files"];
function MountTrigger(props) {
    React.useEffect(() => {
        props.cb();
    }, []);
    return null;
}
class DownloadView extends ComponentEx {
    actions;
    mColumns;
    mTableActions;
    mHeaderRendered = false;
    mLastFiltered;
    constructor(props) {
        super(props);
        this.initState({
            viewAll: false,
        });
        this.actions = [
            {
                icon: "inspect",
                title: "Inspect",
                action: this.inspect,
                condition: (instanceIds) => this.allowActionsDuringCollectionSession(instanceIds) &&
                    this.inspectable(instanceIds[0]),
                multiRowAction: false,
                options: {
                    noCollapse: true,
                },
            },
            {
                icon: "start-install",
                title: "Install",
                action: this.install,
                condition: (instanceIds) => this.allowActionsDuringCollectionSession(instanceIds) &&
                    this.installable(instanceIds),
                hotKey: { code: 13 },
                options: {
                    noCollapse: true,
                },
            },
            {
                icon: "start-install",
                title: "Unpack (as-is)",
                action: this.installAsIs,
                condition: (instanceIds) => this.allowActionsDuringCollectionSession(instanceIds) &&
                    this.installable(instanceIds),
            },
            {
                icon: "pause",
                title: "Pause",
                action: this.pause,
                condition: (instanceIds) => this.allowActionsDuringCollectionSession(instanceIds) &&
                    this.pausable(instanceIds),
            },
            {
                icon: "resume",
                title: "Resume",
                action: this.resume,
                condition: (instanceIds) => this.allowActionsDuringCollectionSession(instanceIds) &&
                    this.resumable(instanceIds),
            },
            {
                icon: "resume",
                title: "Retry",
                action: this.resume,
                condition: (instanceIds) => this.allowActionsDuringCollectionSession(instanceIds) &&
                    this.retryable(instanceIds),
            },
            {
                icon: "delete",
                title: "Delete",
                action: this.remove,
                condition: (instanceIds) => this.allowActionsDuringCollectionSession(instanceIds) &&
                    this.removable(instanceIds),
                hotKey: { code: 46 },
            },
            {
                icon: "stop",
                title: "Cancel",
                action: this.cancel,
                condition: (instanceIds) => this.allowActionsDuringCollectionSession(instanceIds) &&
                    this.cancelable(instanceIds),
            },
            {
                icon: "open-ext",
                title: "Open",
                action: this.open,
                condition: (instanceIds) => this.allowActionsDuringCollectionSession(instanceIds) &&
                    this.installable(instanceIds),
                singleRowAction: true,
            },
        ];
        this.mTableActions = [];
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (!this.mHeaderRendered) {
            // bit of a hack. The toolbar doesn't get rendered until the reference for the
            // portal target is initialized, until then we can't make the update dependent on just
            // the props
            return true;
        }
        return (this.props.downloads !== nextProps.downloads ||
            this.props.downloadPath !== nextProps.downloadPath ||
            this.props.gameMode !== nextProps.gameMode ||
            this.props.knownGames !== nextProps.knownGames ||
            this.props.secondary !== nextProps.secondary ||
            this.props.showDropzone !== nextProps.showDropzone ||
            this.props.showGraph !== nextProps.showGraph ||
            this.props.downloadGameFilter !== nextProps.downloadGameFilter ||
            this.state.viewAll !== nextState.viewAll);
    }
    render() {
        const { t, downloads, gameMode, maxBandwidth, secondary, showGraph } = this.props;
        const { viewAll } = this.state;
        if (this.mColumns === undefined) {
            this.mColumns = this.props.columns(() => this.props);
        }
        let content = null;
        let filteredIds = Object.keys(downloads);
        const { downloadGameFilter, useModernLayout } = this.props;
        if (useModernLayout && downloadGameFilter !== null) {
            filteredIds = filteredIds.filter((dlId) => (downloads[dlId].game ?? []).includes(downloadGameFilter));
        }
        if (filteredIds.length === 0 && gameMode !== undefined) {
            content = this.renderDropzone();
        }
        else {
            if (!viewAll) {
                filteredIds = filteredIds.filter((dlId) => downloads[dlId].installed === undefined);
            }
            const filtered = filteredIds.reduce((prev, dlId) => {
                prev[dlId] = downloads[dlId];
                return prev;
            }, {});
            if (!_.isEqual(filtered, this.mLastFiltered)) {
                this.mLastFiltered = filtered;
            }
            content = (React.createElement(FlexLayout, { type: "column" },
                secondary ? null : React.createElement(Banner, { group: "downloads" }),
                React.createElement(FlexLayout.Flex, { className: "download-list-container" },
                    React.createElement(Panel, { className: "download-panel" },
                        secondary ? null : (React.createElement(Panel, { className: "download-graph-panel", expanded: showGraph, onToggle: nop },
                            React.createElement(Panel.Body, { collapsible: true },
                                React.createElement(DownloadGraph, { t: t, maxBandwidth: maxBandwidth })),
                            React.createElement(CollapseIcon, { position: "bottomright", onClick: this.toggleGraph, visible: showGraph }))),
                        React.createElement(Panel.Body, null,
                            React.createElement(FlexLayout, { type: "column" },
                                React.createElement(FlexLayout.Flex, null,
                                    React.createElement(SuperTable, { tableId: "downloads", data: this.mLastFiltered, staticElements: this.mColumns, actions: this.actions })),
                                React.createElement(FlexLayout.Fixed, { style: { textAlign: "center" } },
                                    React.createElement(Button, { bsStyle: "ghost", onClick: this.toggleViewAll }, viewAll
                                        ? t("View not-yet-installed Downloads")
                                        : t("View All Downloads"))))))),
                React.createElement(FlexLayout.Fixed, { className: "download-drop-container" }, secondary || gameMode === undefined ? null : this.renderDropzone())));
        }
        return (React.createElement(MainPage, null,
            React.createElement(MainPage.Header, null,
                this.mHeaderRendered ? null : React.createElement(MountTrigger, { cb: this.wasRendered }),
                React.createElement(IconBar, { group: "download-actions", staticElements: this.mTableActions, className: "menubar", t: t })),
            React.createElement(MainPage.Body, null, content)));
    }
    wasRendered = () => {
        this.mHeaderRendered = true;
    };
    renderDropzone() {
        const { t, showDropzone } = this.props;
        return (React.createElement(Panel, { className: "download-drop-panel", expanded: showDropzone, onToggle: nop },
            React.createElement(Panel.Collapse, null,
                React.createElement(Panel.Body, null,
                    React.createElement(Dropzone, { accept: DROPZONE_ACCEPT, drop: this.dropDownload, dialogHint: t("Enter download URL"), icon: "folder-download" }))),
            React.createElement(CollapseIcon, { position: "topright", onClick: this.toggleDropzone, visible: showDropzone })));
    }
    toggleViewAll = () => {
        this.nextState.viewAll = !this.state.viewAll;
    };
    toggleDropzone = () => {
        const { showDropzone, onShowDropzone } = this.props;
        onShowDropzone(!showDropzone);
    };
    toggleGraph = () => {
        const { showGraph, onShowGraph } = this.props;
        onShowGraph(!showGraph);
    };
    getDownload(downloadId) {
        return this.props.downloads[downloadId];
    }
    pause = (downloadIds) => {
        downloadIds.forEach((downloadId) => {
            this.context.api.events.emit("pause-download", downloadId);
        });
    };
    /**
     * Determines if actions are allowed for the given download IDs
     * during a collection installation session. Running download actions
     * during a collection installation session can cause problems with
     * the installation process, so we want to prevent that.
     *
     * @param downloadIds the IDs of the downloads for which to check if actions are allowed
     * @returns true if actions are allowed, false otherwise
     */
    allowActionsDuringCollectionSession = (downloadIds) => {
        if (typeof downloadIds === "string") {
            downloadIds = [downloadIds];
        }
        const activeCollectionSession = selectors.getCollectionActiveSession(this.context.api.store.getState());
        if (!activeCollectionSession) {
            // no active collection session - allow all actions.
            return true;
        }
        return (downloadIds.find((downloadId) => {
            const download = this.getDownload(downloadId);
            const tag = download?.modInfo?.referenceTag;
            const identifiers = this.extractIds(download);
            if (!identifiers) {
                return false;
            }
            return (getCollectionModByReference(this.context.api.store.getState(), {
                tag,
                fileId: identifiers.fileId,
                modId: identifiers.modId,
            }) != null);
        }) == null // couldn't find it - allow actions
        );
    };
    pausable = (downloadIds) => {
        return (downloadIds.find((downloadId) => {
            const download = this.getDownload(downloadId);
            return download.state === "started" && download.pausable !== false;
        }) !== undefined);
    };
    reportDownloadError(err, resume) {
        if (err === null) {
            return;
        }
        const urlInvalid = ["moved permanently", "forbidden", "gone"];
        const title = resume
            ? "Failed to resume download"
            : "Failed to start download";
        if (err instanceof ProcessCanceled) {
            this.props.onShowError(title, err, undefined, false);
        }
        else if (err instanceof UserCanceled) {
            // nop
        }
        else if (err instanceof DataInvalid || err instanceof URIError) {
            this.props.onShowError(title, err, undefined, false);
        }
        else if (err instanceof DownloadIsHTML) {
            if (resume) {
                this.props.onShowError(title, "Sorry, the download link is no longer valid. " +
                    "Please restart the download.", undefined, false);
            } // else nop
        }
        else if ((err.HTTPStatus !== undefined &&
            urlInvalid.indexOf(err.HTTPStatus.toLowerCase()) !== -1) ||
            err.message === "No download urls") {
            this.props.onShowError(title, "Sorry, the download link is no longer valid. " +
                "Please restart the download.", undefined, false);
        }
        else if (err instanceof TemporaryError) {
            this.props.onShowError(title, "Downloading failed due to an I/O error (either " +
                "network or disk access). This is very likely a " +
                "temporary problem, please try resuming at a later time.", undefined, false);
        }
        else if (err.code === "ERR_SSL_WRONG_VERSION_NUMBER") {
            this.props.onShowError(title, "Vortex is pre-configured to meet the minimum required security protocol version " +
                "when connecting to the Nexus Mods servers. This error signifies that somewhere along the " +
                "network infrastructure your computer uses to connect to the servers, there " +
                "was a security protocol version mismatch, which can only happen if the infrastructure is using " +
                "outdated protocols - if you are connecting through a proxy server or via VPN, make " +
                "sure they support the latest security protocols (TLS 1.2 at a minimum). " +
                "If the issue persists - please contact our web development team directly as we " +
                "(Vortex support) cannot assist you in this matter.", undefined, false);
        }
        else if (err.message.match(/Protocol .* not supported/) !== null) {
            this.context.api.showErrorNotification(title, err.message, {
                allowReport: false,
            });
        }
        else if (err.code === "EPROTO") {
            log("error", title, err.message);
            this.context.api.showErrorNotification(title, "The download failed due to a SSL protocol error. Protocol errors " +
                "are generally due to a connectivity issue between your system and " +
                "the Nexus Mods servers (usually a temporary issue). If this is " +
                "happening consistently throughout an extensive period of time, " +
                "please report this to the Nexus Mods web team or support@nexusmods.com " +
                "(NOT Vortex support).", { allowReport: false });
        }
        else if (err.code === "CERT_HAS_EXPIRED") {
            this.context.api.showErrorNotification(title, "The download failed due to an SSL certificate expiring. The Nexus Mods certificate " +
                "is renewed regularly weeks or months before expiration and is not the " +
                "cause of this error. Please review the infrastructure (VPN, Proxy, etc) " +
                "through which you are connecting to our servers and try again. Please " +
                "note that some AntiVirus companies hijack the certificate chain as part of their " +
                '"protection" suite - which could also cause this error if their certificate expired', { allowReport: false });
        }
        else if (err.code === "DEPTH_ZERO_SELF_SIGNED_CERT") {
            this.context.api.showErrorNotification(title, "Nexus Mods does not use self-signed certificates. This error signifies that " +
                "your network connection seems to be proxied, either by malware or " +
                "a badly developed firewall, AV, VPN, http proxy; causing valid SSL " +
                "certificates to not be recognized. Please review your system and its " +
                "network connection before trying again.", { allowReport: false });
        }
        else if (err["code"] === "ERR_UNESCAPED_CHARACTERS") {
            this.context.api.showErrorNotification(title, err.message, {
                allowReport: false,
                message: "Invalid URL",
            });
        }
        else if (err.code === "ECONNRESET") {
            this.props.onShowError(title, "Server closed the connection, please " +
                "check your internet connection", undefined, false);
        }
        else if (err.code === "ETIMEDOUT") {
            this.props.onShowError(title, "Connection timed out, please check " + "your internet connection", undefined, false);
        }
        else if (err.code === "ENOSPC") {
            this.props.onShowError(title, "The disk is full", undefined, false);
        }
        else if (err.code === "EBADF") {
            this.props.onShowError(title, "Failed to write to disk. If you use a removable media or " +
                "a network drive, the connection may be unstable. " +
                "Please try resuming once you checked.", undefined, false);
        }
        else if (err.code === "Z_DATA_ERROR") {
            // this indicates the server didn't send gzipped data even though we requested that.
            // This was only observerd when resuming downloads from beatmods.com. It may be their
            // server or the server is reporting capabilities incorrectly or it does and we don't
            // support the config correctly
            this.props.onShowError(title, "Failed to resume download. This may be caused by a misconfiguration on the server " +
                "or Vortex doesn't support resume on this server configuration. " +
                "Apologies for the inconvenience.", undefined, false);
        }
        else if (err.message.indexOf("DECRYPTION_FAILED_OR_BAD_RECORD_MAC") !== -1) {
            this.props.onShowError(title, "Network communication error (SSL payload corrupted). " +
                "This is likely a temporary issue, please try again later.", undefined, false);
        }
        else {
            err["attachLogOnReport"] = true;
            this.props.onShowError(title, err);
        }
    }
    resume = (downloadIds) => {
        downloadIds.forEach((downloadId) => {
            this.context.api.events.emit("resume-download", downloadId, (err) => {
                if (err !== null) {
                    this.openModPage(downloadId);
                    this.reportDownloadError(err, true);
                }
            });
        });
    };
    resumable = (downloadIds) => {
        return (downloadIds.find((downloadId) => this.getDownload(downloadId).state === "paused") !== undefined);
    };
    retryable = (downloadIds) => {
        return (downloadIds.find((downloadId) => this.getDownload(downloadId).state === "failed") !== undefined);
    };
    remove = (downloadIds) => {
        const removeId = (id) => {
            this.context.api.events.emit("remove-download", id, undefined, {
                confirmed: true,
            });
        };
        const { t, onShowDialog } = this.props;
        const downloadNames = downloadIds
            .filter((downloadId) => this.getDownload(downloadId) !== undefined)
            .map((downloadId) => this.getDownload(downloadId).localPath);
        onShowDialog("question", "Confirm Deletion", {
            text: t("Do you really want to delete this archive?", {
                count: downloadIds.length,
                replace: { count: downloadIds.length },
            }),
            message: downloadNames.join("\n"),
            options: {
                translated: true,
            },
        }, [
            { label: "Cancel" },
            { label: "Delete", action: () => downloadIds.forEach(removeId) },
        ]);
    };
    removable = (downloadIds) => {
        const match = ["finished", "failed", undefined];
        return (downloadIds.find((downloadId) => match.includes(this.getDownload(downloadId).state)) !== undefined);
    };
    cancel = (downloadIds) => {
        const { t, onFinishDownload } = this.props;
        const paused = downloadIds.filter((dlId) => this.getDownload(dlId)?.state === "paused");
        const nonPaused = downloadIds.filter((dlId) => this.getDownload(dlId)?.state !== "paused");
        paused.forEach((dlId) => onFinishDownload(dlId, "failed", t("Download was canceled by the user")));
        if (nonPaused.length > 0) {
            this.remove(nonPaused);
        }
    };
    cancelable = (downloadIds) => {
        const match = ["init", "started", "paused", "redirect"];
        return (downloadIds.find((downloadId) => match.includes(this.getDownload(downloadId).state)) !== undefined);
    };
    install = (downloadIds) => {
        const { api } = this.context;
        downloadIds.forEach((dlId) => {
            // not reporting errors here, mod install errors are handled by the InstallManager
            api.events.emit("start-install-download", dlId, undefined, undefined);
        });
    };
    installAsIs = (downloadIds) => {
        downloadIds.forEach((downloadId) => {
            const options = {
                forceInstaller: "fallback",
            };
            this.context.api.events.emit("start-install-download", downloadId, options, undefined);
        });
    };
    installable = (downloadIds) => {
        return (downloadIds.find((id) => this.getDownload(id).state === "finished") !== undefined);
    };
    open = (downloadId) => {
        const { downloadPathForGame, downloads } = this.props;
        const download = downloads[downloadId];
        if (download?.localPath !== undefined) {
            const downloadGame = getDownloadGames(download);
            // Normalize to internal game id for path lookups
            const rawGame = downloadGame[0];
            const games = this.props.knownGames;
            const internalGameId = rawGame
                ? convertGameIdReverse(games, rawGame) || rawGame
                : rawGame;
            if (downloadPathForGame(internalGameId) === undefined) {
                // Not sure under what circumstances we would fail to retrieve a game's
                //  download path. https://github.com/Nexus-Mods/Vortex/issues/7372
                const downloadData = JSON.stringify(download, undefined, 2);
                log("error", "Failed to open archive", downloadData);
                const attachments = [
                    {
                        id: "logfile",
                        type: "file",
                        data: path.join(getVortexPath("userData"), "vortex.log"),
                        description: "Vortex Log",
                    },
                ];
                const err = new Error(`Cannot find download path for ${internalGameId}`);
                err["download"] = download;
                this.props.onShowError("Failed to open archive", err, undefined, true, attachments);
                return;
            }
            opn(path.join(downloadPathForGame(internalGameId), download.localPath)).catch((err) => {
                this.props.onShowError("Failed to open archive", err, undefined, false);
            });
        }
    };
    inspect = (downloadId) => {
        const { t, onShowDialog } = this.props;
        const download = this.getDownload(downloadId);
        if (download === undefined) {
            // the download has been removed in the meantime?
            return;
        }
        if (download.state === "failed") {
            const actions = [
                {
                    label: "Delete",
                    action: () => this.context.api.events.emit("remove-download", downloadId, undefined, { confirmed: true }),
                },
                { label: "Close" },
            ];
            if (download.failCause !== undefined &&
                download.failCause.htmlFile !== undefined) {
                onShowDialog("error", "Download failed", {
                    htmlFile: download.failCause.htmlFile,
                }, actions);
            }
            else if (download.failCause !== undefined &&
                truthy(download.failCause.message)) {
                onShowDialog("error", "Download failed", {
                    text: download.failCause.message,
                }, actions);
            }
            else {
                onShowDialog("error", "Download failed", {
                    message: "Unknown reason",
                }, actions);
            }
        }
        else if (download.state === "redirect") {
            onShowDialog("error", "Received website", {
                message: t("The url lead to this website, maybe it contains a redirection?"),
            }, [
                {
                    label: "Delete",
                    action: () => this.context.api.events.emit("remove-download", downloadId, undefined, { confirmed: true }),
                },
                { label: "Close" },
            ]);
        }
    };
    inspectable = (downloadId) => {
        const download = this.getDownload(downloadId);
        return ["failed", "redirect"].includes(download.state);
    };
    extractIds(download) {
        if (download === undefined) {
            return undefined;
        }
        const isValid = (ids) => ids?.fileId !== undefined &&
            ids?.gameId !== undefined &&
            ids?.modId !== undefined;
        let ids = getSafe(download.modInfo, ["nexus", "ids"], undefined);
        if (isValid(ids)) {
            return ids;
        }
        const meta = getSafe(download.modInfo, ["meta", "details"], undefined);
        if (meta?.fileId !== undefined) {
            ids = {
                fileId: meta.fileId,
                modId: meta.modId,
                gameId: download.game[0],
            };
            if (isValid(ids)) {
                return ids;
            }
        }
        return undefined;
    }
    openModPage = (dlId) => {
        const dl = this.getDownload(dlId);
        const ids = this.extractIds(dl);
        if (ids === undefined) {
            return;
        }
        const url = path.join("www.nexusmods.com", ids.gameId, "mods", ids.modId.toString()) +
            `?tab=files&file_id=${ids.fileId}&nmm=1`;
        opn(url).catch((err) => null);
        return;
    };
    dropDownload = (type, dlPaths) => {
        if (type === "urls") {
            dlPaths.forEach((url) => this.context.api.events.emit("start-download", [url], {}, undefined, (err) => {
                this.reportDownloadError(err, false);
            }));
        }
        else {
            this.context.api.events.emit("import-downloads", dlPaths);
        }
    };
}
function mapStateToProps(state) {
    return {
        gameMode: selectors.activeGameId(state),
        knownGames: state.session.gameMode.known,
        downloads: state.persistent.downloads.files,
        downloadPath: selectors.downloadPath(state),
        showDropzone: state.settings.downloads.showDropzone,
        showGraph: state.settings.downloads.showGraph,
        maxBandwidth: state.settings.downloads.maxBandwidth,
        useModernLayout: state.settings.window.useModernLayout,
        downloadGameFilter: state.session.base?.downloadGameFilter ?? null,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSetAttribute: (id, time) => dispatch(setDownloadTime(id, time)),
        onShowDialog: (type, title, content, actions) => dispatch(showDialog(type, title, content, actions)),
        onShowError: (message, details, notificationId, allowReport) => showError(dispatch, message, details, {
            id: notificationId,
            allowReport,
        }),
        onShowDropzone: (show) => dispatch(setShowDLDropzone(show)),
        onShowGraph: (show) => dispatch(setShowDLGraph(show)),
        onFinishDownload: (dlId, dlState, failReason) => dispatch(finishDownload(dlId, dlState, { message: failReason })),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(translate(["common"])(DownloadView));
